import { Request as request } from "@/utils/request"

/**
 * 获取好友列表
 * @param {{
 * page:number
 * }} params  page 页码数
 * @returns
 */
let getFriends = (params) => {
    return request("/api/common/friends-list", {
        method: "POST",
        params
    })
}

// /api/common/fetch-shareid
/**
 * 获取分享ID
 * @param {*} params
 * @returns
 */
let fetchShareId = (params) => {
    return request("/api/common/fetch-shareid", {
        method: "POST",
        params
    })
}

export {
    getFriends,
    fetchShareId,
}
